import { jsx as _jsx } from "react/jsx-runtime";
import { FlavorFinderContextProvider, FlavorFinderViewSwitch } from "./components";
import "./FlavorFinder.scss";
export const FlavorFinder = ({ data }) => {
    return (_jsx(FlavorFinderContextProvider, { data: data, children: _jsx("div", { className: "flavorfinder__container", children: _jsx(FlavorFinderViewSwitch, {}) }) }));
};
//# sourceMappingURL=FlavorFinder.js.map